import AxiosCustom from "../../../../components/common/apiConfigPouyan/index";


export function select_online_contarct_api(payload) {

  const config = {

    url: `/UpdateContract/GetOnlineContracts/OnlineContract`,
    method:'GET'
  };

  const data = payload?.data?.body

  const header = {
    ...payload?.headers
  }

  return AxiosCustom(config, data, header);
}
